import type { Schema, SchemaField } from '@cli-types/core-engine/schema.js'
import type { SchemaPromptContext } from '@cli-types/next-adapter/commands.js'
import { displayLabel } from './display-label.js'
import { promptConfirm } from './prompt-confirm.js'
import { schemaColumnTypeForField } from './schema-column-type-for-field.js'

export async function promptEntityIntegrationOptions(
  context: SchemaPromptContext,
  schema: Schema,
  field: SchemaField
): Promise<string[]> {
  const summary: string[] = []
  const columnType = schemaColumnTypeForField(field)
  if (columnType) {
    const addColumn = await promptConfirm(context, 'Add this field to the table columns?', false)
    if (addColumn) {
      schema.columns = schema.columns ?? []
      schema.columns.push({
        accessorKey: field.name,
        header: displayLabel(field),
        type: columnType
      })
      summary.push(`table column: ${field.name}`)
    }
  }

  if (['string', 'email', 'varchar', 'text', 'markdown', 'richtext'].includes(field.type)) {
    const addSearch = await promptConfirm(context, 'Add this field to search?', false)
    if (addSearch) {
      schema.search = schema.search ?? { fields: [] }
      schema.search.fields = Array.from(new Set([...schema.search.fields, field.name]))
      summary.push(`search field: ${field.name}`)
    }
  }

  if (field.type === 'select' || field.type === 'boolean') {
    const addFilter = await promptConfirm(context, 'Add this field as a list filter?', false)
    if (addFilter) {
      schema.filters = schema.filters ?? []
      schema.filters.push({
        field: field.name,
        label: displayLabel(field),
        type: field.type === 'boolean' ? 'boolean' : 'select',
        ...(field.type === 'select' && field.options?.length
          ? {
              source: 'static' as const,
              options: field.options
            }
          : field.type === 'select'
            ? { source: 'distinct' as const }
            : {})
      })
      summary.push(`filter: ${field.name}`)
    }
  }

  return summary
}
